export class DimensionOptionResultDto {
    dimensionCode: string;
    dimensionOptionCode: string;
    dimensionTitle: string;
    dimensionOptionTitle: string;
}
